export default "__VITE_ASSET__9Vx7Ahph__"